__webpack_require__.p = "/rick_morty/";